/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT ///
import { useEffect } from "react";
import { useState } from "react";
/// ROUTER ///
import { useParams } from "react-router-dom";
/// TYPES ///
import { IPriceControl } from "api/types/price_list/price_control";
/// ACTIONS ///
import { getPriceList } from "api/actions/price_list";
import { getPriceControls } from "api/actions/price_list";
import { updatePriceControls } from "api/actions/price_list";
import { getShopInstallationCharges } from "api/actions/price_list";
import { getShopFabricationCharges } from "api/actions/price_list";
import { setBreadcrumbs } from "api/actions/ui/set";
/// MUI ///
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
/// COMPONENTS ///
import FabricationCharge from "./fabrication_charge";
import InstallationCharge from "./installation_charge";
import Loading from "components/universal/loading";
import PageTitle from "components/universal/page/title";
import PriceControlSwitch from "components/price_lists/price_control/switch";
/// FM ///
import { motion } from "framer-motion";
/// STYLES ///
import { content_container_style } from "styles/universal/page";
import { header_style } from "styles/universal/section_header";
import { list_container_style } from "styles/universal/page";
import { title_style } from "styles/quote_preview/section";
/// MOTION ///
import { m_init_page } from "motion/page";
import { m_anim_page } from "motion/page";
import { m_exit_page } from "motion/page";
import { page_trans } from "motion/page";
/// BREADCRUMBS ///
import { list } from "values/breadcrumbs/market/pl";
import { overview } from "values/breadcrumbs/market/pl";

export default function LaborPriceList() {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const { price_list } = useAppSelector(state => state.price_list);
  const { installation_charges } = useAppSelector(state => state.price_list);
  const { fabrication_charges } = useAppSelector(state => state.price_list);
  const { price_controls } = useAppSelector(state => state.price_list);
  const { updating } = useAppSelector(state => state.price_list);
  const [update_price_control, setUpdatePriceControl] = useState<IPriceControl>({});

  useEffect(() => {
    setUpdatePriceControl(price_controls);
  }, [price_controls?.id]);

  useEffect(() => {
    if (!(price_list?.id) || price_list.id.toString() !== id) {
      dispatch(getPriceList(id));
    }
  }, [dispatch, id, price_list?.id]);

  useEffect(() => {
    if (id) {
      dispatch(getPriceControls());
      dispatch(getShopInstallationCharges(id));
      dispatch(getShopFabricationCharges(id));
    }
    dispatch(setBreadcrumbs([list, { ...overview, url: overview.url.replace("id", id) }]));
  }, [id, dispatch]);

  return (
    <motion.div initial={m_init_page} exit={m_exit_page} animate={m_anim_page} transition={page_trans} style={content_container_style}>
      <Grid container sx={list_container_style}>
        <PageTitle title={`${price_list?.name} Labor Charges` ?? ""} endProps={<div></div>} />
        <Grid container item xs={12} justifyContent="space-between">
          <Grid item xs={12}>
            <Box sx={header_style}></Box>
          </Grid>
          <Grid item xs={6} sx={{ marginTop: "10px", marginBottom: "15px" }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h6" sx={title_style}>
                Fabrication Charges
              </Typography>
              <PriceControlSwitch
                checked={update_price_control?.use_fabrication_charge}
                onChange={checked => {
                  setUpdatePriceControl({ ...update_price_control, use_fabrication_charge: checked });
                  dispatch(updatePriceControls({ use_fabrication_charge: checked }, price_controls?.id));
                }} />
            </Stack>
          </Grid>
          <Grid item xs={6}></Grid>
          {
            update_price_control?.use_fabrication_charge ?
              fabrication_charges.map((fabrication_charge, index) => <FabricationCharge key={index} index={index} fabrication_charge={fabrication_charge} last={index === fabrication_charges.length - 1} />) : null
          }
          <Grid item xs={6} sx={{ marginTop: "10px", marginBottom: "15px" }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h6" sx={title_style}>
                Installation Charges
              </Typography>
              <PriceControlSwitch
                checked={update_price_control?.use_installation_charge}
                onChange={checked => {
                  setUpdatePriceControl({ ...update_price_control, use_installation_charge: checked });
                  dispatch(updatePriceControls({ use_installation_charge: checked }, price_controls?.id));
                }} />
            </Stack>
          </Grid>
          <Grid item xs={6}></Grid>
          {
            update_price_control?.use_installation_charge ?
              installation_charges.map((installation_charge, index) => <InstallationCharge key={index} index={index} installation_charge={installation_charge} last={index === installation_charges.length - 1} />) : null
          }
        </Grid>
      </Grid>
      <Loading loading={updating} />
    </motion.div>
  )
}
